import { useQuery } from "@apollo/client/react";

import _ from "lodash";
import { getConfigurationQuery } from "../../Queries";
import useSetupConfigurationContext from "../useSetupConfigurationContext";

function useConfigurations({
  variables,
  fetchPolicy = "cache-and-network",
  skip,
  configurationKey = "NOT_DEFINED",
  configurationKeys = [configurationKey],
}) {
  const { data, loading, networkStatus } = useQuery(getConfigurationQuery, {
    variables,
    fetchPolicy,
    skip: skip,
    context: {
      useHttpLink: true,
    },
  });

  useSetupConfigurationContext({
    configurationKeys,
    configurationLists: _.map(
      _.get(data, "platform.configuration"),
      ({ configurations }) => configurations
    ),
  });

  return {
    data,
    loading,
    networkStatus,
  };
}

export default useConfigurations;
